module.exports = __webpack_public_path__ + "static/media/kaweco.ea6cb757.png";